import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, NavParams, Platform, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { Navigator } from 'src/app/services/routing/navigator';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { RoutingService } from 'src/app/services/routing/routing.service';

@Component({
  selector: 'app-enroll-boyd-rewards',
  templateUrl: './enroll-boyd-rewards.component.html',
  styleUrls: ['./enroll-boyd-rewards.component.scss'],
})
export class EnrollBoydRewardsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(IonContent, { static: false }) content: IonContent;

  error = null;
  customer;
  buttonDisabled = false;
  callBackFn;
  browserRefresh: boolean;
  linkCardDisabled = false;
  textContent: Record<string, string> = {};
  customerProfileMatched = false;
  linkLoyaltyCardDisabled = false;
  linkLoyaltyCardMaxTried = false; Ï
  loyaltyCardForm: FormGroup;
  loyaltyCardNumber: AbstractControl<string>;
  boydSub: Subscription;

  constructor(
    private boydRewardsService: BoydRewardsService,
    private navigator: Navigator,
    private userSession: UserSessionService,
    private navParams: NavParams,
    private siteContentService: SiteContentService,
    private toastController: ToastController,
    public utils: UtilsService,
    public successMessageService: SuccessMessageService,
    private routing: RoutingService,
    private platform: Platform
  ) {
    this.successMessageService.clearMessage();
  }

  ngOnInit() {
    this.loyaltyCardForm = new FormGroup({
      loyaltyCardNumber: new FormControl('', [
        Validators.required,
        // Validators.pattern('^[0-9]+$'),
        Validators.minLength(6),
        // Validators.maxLength(20),
      ]),
    });
    this.loyaltyCardNumber = this.loyaltyCardForm.get('loyaltyCardNumber');

    this.userSession.getCustomer().subscribe(customer => {
      this.customer = customer;
    });

    this.callBackFn = this.navParams.get('callBackFn');
  }

  ngAfterViewInit() {
    this.siteContentService
      .loadConfig('boyd_enroll_reward')
      .then((response: Record<string, string>) => {
        this.textContent = response;
      });
  }

  onHaveBoydCard() {
    this.navigator.navigateTo('BoydRewardsConnectComponent', '', {
      navigateBackPage: 'EnrollBoydRewardsComponent',
      connectBoydCardPath: false,
      callBackFn: this.navParams.get('callBackFn'),
    });
  }

  onSubmit() {
    this.buttonDisabled = true;
    const obj = {
      session_token: this.userSession.getSessionToken(),
      // driver_licence: this.driverLicense.value,
      customer_id: this.customer.customerId,
      // pin:this.pin.value,
      // confirmPin: this.pinConfirm.value
    };
    this.boydRewardsService.callEnrollPlayerRewards(obj)
      .subscribe(
        res => {
          if (res && res.result) {
            this.boydRewardsService
              .checkConnectionToBoydCard()
              .subscribe(
                res => {
                  this.presentToast('Your Boyd Rewards Account is now active');
                  this.linkCardDisabled = true;
                  //Temporary removing timeout as it's causing callBack function to kick in.
                  // setTimeout(()=> {
                  if (this.callBackFn) {
                    this.navigator.dismiss();
                    this.callBackFn();
                  } else {
                    // setTimeout(() => {
                    this.routing.defaultRoute();
                    // }, 3000);
                  }
                  // },3000);
                },
                err => {
                  this.error = err;
                  if (this.callBackFn) {
                    this.navigator.dismiss();
                    this.callBackFn();
                  }
                  switch (err.getErrorCode().toUpperCase()) {
                    case 'CARD_ALREADY_EXISTS':
                      err.setErrorMessage('Reward Card already exists');
                      break;
                    default:
                      err.setErrorMessage(
                        'Oops! We cannot confirm your account information'
                      );
                      break;
                  }
                }
              )
              .unsubscribe();
          } else {
            if (this.callBackFn) {
              this.navigator.dismiss();
              this.callBackFn();
            }
          }
        },
        err => {
          switch (err.getErrorCode().toUpperCase()) {
            case 'CUSTOMER_NOT_FOUND':
              err.setErrorMessage('Sorry! Customer cannot be found');
              break;
            case 'CARD_ALREADY_EXISTS':
              err.setErrorMessage('Sorry! Reward Card already exists');
              break;
            case 'CONNECTION_ERROR':
              err.setErrorMessage('Sorry! There was a connection error');
              break;
            case 'CUSTOMER_PROFILE_MATCHED':
              // stay at this UI and let user input the reword card
              this.customerProfileMatched = true;
              return;
            default:
              err.setErrorMessage('Oops! We cannot confirm your account information');
              break;
          }
          this.error = err;
        }
      );
  }

  callEnroll() {
    const obj = {
      session_token: this.userSession.getSessionToken(),
      customer_id: this.customer.customerId,
    };
    this.boydRewardsService.callEnrollPlayerRewards(obj).subscribe(
      res => {
        if (res.result) {
          this.boydRewardsService.connectBoydCardToStardust();
        }
      },
      err => {
        switch (err.getErrorCode().toUpperCase()) {
          case 'CUSTOMER_NOT_FOUND':
            err.setErrorMessage('Sorry! Customer cant be found');
            break;
          case 'CARD_ALREADY_EXISTS':
            err.setErrorMessage('Sorry! Reward Card already exists');
            break;
          case 'CONNECTION_ERROR':
            err.setErrorMessage('Sorry! There was a connection error');
            break;
          case 'CUSTOMER_PROFILE_MATCHED':
            // stay at this UI and let user input the reword card
            this.customerProfileMatched = true;
            return;
        }
      }
    );
  }

  linkLoyaltyCard() {
    if (!this.loyaltyCardForm.valid) {
      return;
    }
    const loyaltyCardNumber = this.loyaltyCardNumber.value;
    this.linkLoyaltyCardDisabled = true;
    this.boydRewardsService.linkRewardCard(loyaltyCardNumber).subscribe(
      res => {
        if (res.result) {
          this.boydSub = this.boydRewardsService
            .checkConnectionToBoydCard()
            .subscribe(
              res => {
                this.presentToast('Your Boyd loyalty card is now linked with your account.')
                this.callBackOrGoLobby();
              });
        }
      },
      err => {
        switch (err.getErrorCode().toUpperCase()) {
          case 'CUSTOMER_NOT_FOUND':
            err.setErrorMessage('Sorry! Invalid reward card');
            break;
          case 'CUSTOMER_ALREADY_ENROLLED':
            err.setErrorMessage('Sorry! Customer already enrolled');
            break;
          case 'CONNECTION_ERROR':
            err.setErrorMessage('Sorry! There was a connection error');
            break;
          case 'MAX_ATTEMPTS_REACHED':
            err.setErrorMessage('Too many failed attempts');
            this.linkLoyaltyCardMaxTried = true;
            break;
          default:
            err.setErrorMessage(err.getErrorMessage());
            break;
        }
        this.content.scrollToTop(10);
        this.linkLoyaltyCardDisabled = false;
        this.error = err;
      }
    );
  }

  closeModal = () => {
    this.callEnroll();
    //callBack
    this.callBackOrGoLobby()
  };

  callBackOrGoLobby() {
    if (this.callBackFn) {
      this.navigator.dismissAll();
      this.callBackFn();
    }
    else {
      //this.routing.defaultRoute();
      this.navigator.dismissAll('');
    }

  }
  ngOnDestroy() {
    if (this.boydSub) {
      this.boydSub.unsubscribe();
    }
  }

  async presentToast(toast_message) {
    let toastCssClass = "test";
    if(this.platform.is("capacitor")) {
      toastCssClass = "toast-safe-area-adjust";
    }
    const toast = await this.toastController.create({
      message: toast_message,
      position: 'top',
      duration: 5000,
      cssClass: toastCssClass,
      color: "secondary",
      buttons: [
        {
          text: 'Close',
          role: 'close',
          handler: () => { }
        }
      ]
    });

    await toast.present();
  }
}
